import { 
    SIGN_OUT,
    DOWNLOAD_ROAD_TICKET_INSURANCE, 
    SHOW_DOWNLOAD_INSURANCE_DIALOG, 
    HIDE_DOWNLOAD_INSURANCE_DIALOG,
    ROAD_TICKET_INSURANCE_DETAILS,
    SHOW_INSURANCE_DETAILS_DIALOG,
    HIDE_INSURANCE_DETAILS_DIALOG,
    ROAD_TICKET_INSURANCE_PRICE,
    SET_INSURANCE_PRICE
} from "constants/ActionTypes";

const INIT_STATE = {
    doShowDownloadInsuranceDialog: false,
    insurancePDFData: null,
    doShowInsuranceDetailsDialog: false,
    insuranceDetails: null,
    insurancePrice: [],
    insurancePriceTotalValue: null,
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case SIGN_OUT: {
            return INIT_STATE;
        }

        case SHOW_DOWNLOAD_INSURANCE_DIALOG: {
            return {
                ...state,
                doShowDownloadInsuranceDialog: true,
            }
        }

        case HIDE_DOWNLOAD_INSURANCE_DIALOG: {
            return {
                ...state,
                doShowDownloadInsuranceDialog: false,
            }
        }

        case DOWNLOAD_ROAD_TICKET_INSURANCE: {
            return {
                ...state,
                insurancePDFData: action?.payload,
            }
        }

        case SHOW_INSURANCE_DETAILS_DIALOG: {
            return {
                ...state,
                doShowInsuranceDetailsDialog: true,
            }
        }

        case HIDE_INSURANCE_DETAILS_DIALOG: {
            return {
                ...state,
                doShowInsuranceDetailsDialog: false,
            }
        }

        case ROAD_TICKET_INSURANCE_DETAILS: {
            return {
                ...state,
                insuranceDetails: action?.payload,
            }
        }

        case ROAD_TICKET_INSURANCE_PRICE: {
            return {
                ...state,
                insurancePrice: action?.payload,
            }
        }

        case SET_INSURANCE_PRICE: {
            return {
                ...state,
                insurancePriceTotalValue: action.payload
            };
        }

        default: {
            return state;
        }
    }
}